// 参考：
// https://www.cnblogs.com/dengyao-blogs/p/11562257.html

/* jshint esversion: 6 */

import Vue from 'vue';
import App from './App';
import router from './router.js';
Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  router
}).$mount('#app');


/* eslint-disable no-new */
// new Vue({
//   el: '#app',
// //一定要注入到vue的实例对象上
//   router,
//   components: { App },
//   template: '<App/>'
// });